import { z } from 'zod'
import {
  Address,
  HexNumber,
} from '@lukso/controllerapps-sharedlogic-primitives'

import { CustomControllerName } from '../../CustomControllerName'
import { ControllerAddress } from '../../ControllerAddress'

export const CustomControllerNameSchema = z.object({
  address: z.string(),
  name: z.string(),
})

type CustomControllerNamesReportText = z.infer<
  typeof CustomControllerNameSchema
>[]

export function mapDomainToReportText(
  customControllerNames: CustomControllerName[]
): CustomControllerNamesReportText {
  return customControllerNames.map(customControllerName => ({
    address: customControllerName.getAddress().getChecksumValue(),
    name: customControllerName.getName(),
  }))
}

export function mapReportTextToDomain(
  customControllerNamesReportText: CustomControllerNamesReportText
): CustomControllerName[] {
  return customControllerNamesReportText.map(customControllerNameReportText => {
    const { address, name } = customControllerNameReportText
    return CustomControllerName.create({
      address: ControllerAddress.create({
        controllerAddressValue: Address.create({
          addressValue: HexNumber.create({ hexNumberValue: address }),
        }),
      }),
      name: name,
    })
  })
}
